class BbcCardSlider {
  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector('[data-bbc-track]');
    this.slides = Array.from(slider.querySelectorAll('[data-bbc-slide]'));
    this.indicator = slider.querySelector('.bbc-card-slider__indicator');

    if (!this.track || this.slides.length < 2 || !this.indicator) return;

    this.startX = 0;
    this.hasMoved = false;
    this.ticking = false;

    this.indicator.style.setProperty('--bbc-count', this.slides.length);
    this.indicator.style.setProperty('--bbc-index', 0);

    this.bindEvents();
    this.updateIndicator();
  }

  bindEvents() {
    this.track.addEventListener(
      'scroll',
      () => {
        if (this.ticking) return;

        this.ticking = true;

        window.requestAnimationFrame(() => {
          this.updateIndicator();
          this.ticking = false;
        });
      },
      { passive: true }
    );

    this.track.addEventListener(
      'touchstart',
      (event) => {
        this.startX = event.touches[0].clientX;
        this.hasMoved = false;
      },
      { passive: true }
    );

    this.track.addEventListener(
      'touchmove',
      (event) => {
        const currentX = event.touches[0].clientX;

        if (Math.abs(currentX - this.startX) > 8) {
          this.hasMoved = true;
        }
      },
      { passive: true }
    );

    this.slides.forEach((slide) => {
      slide.addEventListener('click', (event) => {
        if (this.hasMoved) {
          event.preventDefault();
        }
      });
    });

    window.addEventListener(
      'resize',
      () => {
        this.updateIndicator();
      },
      { passive: true }
    );
  }

  updateIndicator() {
    const width = this.track.clientWidth;

    if (!width) return;

    const rawIndex = this.track.scrollLeft / width;

    const index = Math.max(
      0,
      Math.min(
        this.slides.length - 1,
        Math.round(rawIndex)
      )
    );

    this.indicator.style.setProperty('--bbc-index', index);
  }
}

function initBbcCardSliders(scope = document) {
  const sliders = scope.querySelectorAll('[data-bbc-card-slider]');

  sliders.forEach((slider) => {
    if (slider.dataset.bbcInitialized === 'true') return;

    slider.dataset.bbcInitialized = 'true';

    new BbcCardSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBbcCardSliders();
});

document.addEventListener('shopify:section:load', (event) => {
  initBbcCardSliders(event.target);
});